import ApiHelper from "~/helpers/api-helper";

export default class CityService {

	public static getSelectorList($axios, id) {
		return $axios.get(`/v1/city/filter?country_id=${id}`);
	}

	public static getSelectorTravelList($axios, pagination, filters = {}) {
		const params = ApiHelper.setQueryParams(pagination, filters);
		params.append('status_id', '1');
		return $axios.$get('/travel/filter', { params: params });
	};

	public static getSelectorListPackageCity($axios, pagination, filters = {}) {
		const params = ApiHelper.setQueryParams(pagination, filters);
		params.append('status_id', '1');
		return $axios.get(`/public-travel_pack/filter-city`, { params: params });
	}

}
